<script setup>
import { DatePicker } from 'v-calendar'
</script>

<template>
    <DatePicker>
        <template #default="{ inputValue, inputEvents }">
            <v-text-field
                :value="inputValue.start === null ? '' : inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                variant="outlined"
                placeholder="За все время"
            />
        </template>
    </DatePicker>
</template>

<style scoped lang="scss">
:deep(.v-field__input)::placeholder {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #002866;
    opacity: 0.6;
}
</style>